export default __webpack_public_path__ + "static/media/26_tag_lounge.436ff3d3.svg";